module.exports = __webpack_public_path__ + "img/base_model3.28bfc2ce.png";